import { useQueryWithUserId } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

/**
 * This is to track the category filter query key in react query cache.
 */
export const CATEGORY_FILTER_KEY = 'category-filter-key';

/**
 * This performs a filter request and retrieves the category filter options,
 * brand filter options and rank report.
 * Provides data fetching states to be used in the dropdowns.
 */
export const useBidsCategoryQuery = () => {
  const { isPending, isError, error, refetch, isFetching, data } =
    useQueryWithUserId({
      queryKey: [CATEGORY_FILTER_KEY],
      networkMode: 'always', // Even make calls when offline
      queryFn: BIDS_API.fetchAllBidCategoryFilters,
      staleTime: 5 * 1000 * 60, // 5 seconds
    });
  return {
    data,
    error,
    isError,
    isFetching,
    isPending,
    refetch,
  };
};
